export const setupWizard = {
  top: {
    title: "Setup assistant",
    subtitleFallback: "Basic listing setup",
    stepCount: "Step {current} of {total}",
    closeAria: "Close assistant",
    closeTitle: "Close",
  },
  intro: {
    title: "Let's set up your accommodation together!",
    subBefore: "We'll guide you step by step to get",
    yourListingFallback: "your listing",
    subAfter: "ready to welcome guests. No tech skills needed: you'll have it all set in a few minutes. 😊",
    start: "Get started!",
    skip: "Not now, I'll do it later",
  },
  steps: {
    confirmation: {
      label: "Booking confirmation",
      desc: "We let the guest know their booking is confirmed by WhatsApp and email. Turn this off and they won't be notified. If they book through an OTA, the OTA notifies them.",
    },
    welcome: {
      label: "Welcome message",
      desc: "The message the guest receives right after completing their online check-in, with the welcome and arrival instructions.",
    },
    schedule: {
      label: "Check-in scheduling",
      desc: "When would you like us to send the guest the check-in link?",
    },
    hours: {
      label: "Check-in and check-out times",
      desc: "What time can the guest arrive and leave?",
    },
    locks: {
      label: "Lock type",
      desc: "How does the guest get into your accommodation?",
    },
    authorities: {
      label: "Authority reporting",
      desc: "We send the traveler report to the authorities for you, with nothing for you to do.",
    },
    services: {
      label: "Services",
      desc: "Set up the services and amenities your accommodation offers.",
    },
    policies: {
      label: "Policies",
      desc: "Your accommodation's rules and conditions.",
    },
    calendar: {
      label: "Prepare your calendar",
      desc: "We'll show you how to get your calendar ready to take bookings.",
    },
  },
  nav: {
    back: "Back",
    next: "Next",
    finish: "Finish",
  },
  preview: {
    audienceOwner: "What you see (host)",
    audienceGuest: "What the guest sees",
    accommodationFallback: "Accommodation",
    online: "online",
    today: "Today",
    captionGuestWeb: "Preview · guest web",
  },
  schedule: {
    title: "When does check-in start?",
    hint: "Schedule when the agent sends the check-in link to the guest. Applies at listing level.",
    caption: "Preview · check-in sequence",
  },
  // WhatsApp bot sample messages: shown VERBATIM (bilingual ES+EN) in every
  // language because they mirror the actual product message.
  checkin: {
    propFallback: "tu alojamiento",
    greeting: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{name}*.\nEstoy aquí para ayudarte con el proceso de check-in.\n\nPresiona 'Ok' para continuar con el check-in.\n\n🇬🇧 *Hi* 👋 I'm 🤖 the virtual assistant of *{name}*.\nI'll help you with the check-in process.\n\nPress 'Ok' to continue with the check-in.",
    quote: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{name}*. Estoy aquí para ayudarte con el proceso de che…",
    subCheckin: "Vamos a hacer el check-in · Let's check-in",
    ok: "Ok",
    chooseLang: "Elige tu idioma",
    langEs: "Español",
    langEn: "English",
    thanks: "*Gracias* 👋 Este es tu link para hacer el Check-In. 😎",
  },
  confirmation: {
    toggleLabel: "Do you want the booking confirmation sent to the guest by WhatsApp?",
    toggleHint: "As soon as a booking is confirmed, they'll get this message with all their stay details. That way they know everything's in order. 😊",
    stateOn: "Yes, send it",
    stateOff: "Don't send",
    mapAlt: "Accommodation location",
    addressFallback: "Accommodation address",
    caption: "Preview · confirmation message",
    propFallback: "your accommodation",
    guestSample: "Laura García",
    body: "Hi *{guest}* 👋\n\nYour booking at *{name}* is confirmed ✅\n\nBooking code: *6233Q1VC5*\nDates: *05/06/2026* – *07/06/2026* 📅\n\nThrough this WhatsApp you can request your online check-in link and receive the arrival instructions.\nIf you need help before or during your stay, message us here 💬",
    cta: "🇬🇧 To continue with check-in, tap the *Ok* button or type *Ok*.",
  },
  policies: {
    guestBubble: "To continue with the process you must accept our terms and conditions.",
    termsTitle: 'Rules and Regulations · TOURIST ACCOMMODATION "{name}"',
    termsBodyLabel: "I.– REGISTRATION",
    termsBodyText: "Every guest, whether individual or part of a group, must fill in a registration form individually or per room, which will be provided on arrival or online.",
    accept: "I accept the terms and conditions",
  },
  guestPreview: {
    continue: "Continue",
  },
  authorities: {
    ofTotal: "of {total}",
    heading: "Information required under Royal Decree 933/2021 of the Government of Spain",
    intro: "Under Royal Decree 933/2021, effective 2 December 2024, we need to collect the following data to comply with security regulations.",
    countryLabel: "Country of residence",
    sampleCountry: "🇪🇸 Spain",
    cityLabel: "City of residence",
    sampleCity: "Málaga",
    addressLabel: "Residential address",
    sampleAddress: "77 Larios Street",
    postalLabel: "Residential postal code",
  },
  locks: {
    embedEmpty: "Add a unit to the listing first to configure locks and access.",
  },
  calendar: {
    iframeTitle: "Prepare your calendar",
    videoSoon: "The video will be available here very soon.",
    hint: "Play the video and follow the steps: in no time your calendar will be ready to take bookings. 🎬",
  },
};
